// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1P7LQ","label":"styles_label__1tq3Q","input":"styles_input__1b7NO","error":"styles_error__3Il2S"};